import { createApp } from 'vue';
import PictToPdfConverter from '../Components/PictToPdfConverter.vue';

createApp(PictToPdfConverter).mount('#pict-to-pdf-converter');
